import * as Cryptography from "./Cryptography";
import FormData from "../models/FormData";
import ValueLabel from "../models/valueLabel";

const keys = {
    storeInstallerInformation: "6f3c30c2c0f0c5b966ccb313e816ad13624daac7526e1d08ff896bd62ec82bcd36fd3f323edc31837bea9cf424192eca4202209d534dc27d4e7600934f5705d4",
    cellphone: "10c08119fc1aa172bd850bef0af84cc1cf95d385be673bf9dccc50058edb51aa4322e19f039d9b6c8fa71eab27d322cdba507eacc517b4e96ad06d6dbda042ea6f6d5f5ff3",
    name: "4105522d9e62edc991afffd45a6bd662774b18827c5a9c1f425ad0118cf992d36e92b7128f346023b3d4acd30d5d12755c8b071dc168338f8306bad3e98ff27d",
    deviceId: "127188f856689a517b4e96ad06d6dbda049184748b7ce2e9068793b1d6f6e516f9117d315f7bc2b24306cad01337494037f2e4cb03cd6b269929eab8ab99727f",
    preRequestId: "fe25c047aa2ba48b9c269e92921122b0d7af23e666b16902cb0e24994fbc7d350f5b26f66b47cc85a2c851125cb311d840ef0ce0f72d2f8e57dba672a1191d8e",
    goToForm: "749cd34e62f2cae59bdd0486d65e178b59ecb296858d52317b994a4bca849d213e0fefd6e090c03d408111cc10eab9c2b7815274af8279fe158bfa9e7814a873",
    formData: "783d91cca04c9af2208952894cb40ea750876cb06e7765debab02b1698be3df878be4f6d5a333bfd25811cb38bcb9f94bd0564f3f15c39d60ff396036f5043c0",
    user: "783d91cca04c9af2208952894c517b4efbc7d350f5b26f66b47cc85a6dbda04b40ea750876cb06e7765debab02b1698be3df878be4f6d037f2e4cb03c17b6b269929eab8ab0",
    currentFileNumber: "783d91cca02cb0269e92921122b0d7af23e666b16902cb026f66b47cc7650f5b26f66b47ccc10ea0564f3f15c39d60ff39d60ff396036f50436b269929eab8ab0",
    data: "483d91cca02cb004b40ea750876cb26f66b47cc85a6d2c851125cb311d8440ea66b47cc7650f5b26f66b47ccc10cf424192eca420d0564f3f15c3cf424192eca420f50436b269929eab8ab0",
    accountTypes: "403d91cca02cb004b40ea750876cb26f66b47cb7ce2e9068793b17cc7650f5b26f66b47ccc10cf424192eca420d0564f3f15c3cf424192eca420f50436b269929eab8ab0",
    cities: "401d91cca02cb004b40ea750876cb26f66b47cb7ce2e9068793b17cc7650f5b16f9117d315f7bc2c10cf424192eca420d0564f3f15c3cf424192eca420f50436b269929eab8ab0",
    units: "400d91cca02cb004b40ea750876cb268be3df87893b17cc7650f5b16f9117d31994fbc7d350f5b26f66b64f3f15c3cf424192eca420f50436b269929eab8ab0",
    billingReviewTypes: "3990d91cca02cb004b40ea750876cb268be3df87893b17cc7650f5b16f9117d31994fbc7d350f5b26f66b64f3f15c3cf424192eca420f50436b269929eab8ab0",
    legalFacilitiesRequestType: "3390d91cca02cb004b40ea750876cb268be3df87893b17cc7650d12755c8b3cf424192e3cf424192eca420f50436b269929eab8ab0",
    constructionDocumentType: "3390d91cca02cb004b40ea750876cb268be3df87893b17cc7650d12755c8b3cf424192e3cf424192eca420f50436b269929eab8ab0",
    branchInfo: "34440d91cca02cb004b4e9068ca6f66b64f3f15c67893b17cc7650d126f66b64f3f15ca02cb0036b269929eab8ab0",
    token: "34440d91cca02cb004b4cb268be3e9068cae3df87893b17cc76507cb7ce2e9f5b16f9117d311287893b17cc7650d12755cfbc7cf424192eca420d0564b0",
};

function setCellphone(argCellphone: string) {
    localStorage.setItem(keys.cellphone, Cryptography.encriptString(argCellphone));
}
function getCellphone() {
    return(Cryptography.decriptString(localStorage.getItem(keys.cellphone)));
}

function setFileNumber(currentFileNumber: string) {
    localStorage.setItem(keys.currentFileNumber, Cryptography.encriptString(currentFileNumber));
}
function getFileNumber() {
    return(Cryptography.decriptString(localStorage.getItem(keys.currentFileNumber)));
}
function setUser(user:any){
    localStorage.setItem(keys.user,Cryptography.encriptString(JSON.stringify(user)))
}
function clearUser(){
    localStorage.removeItem(keys.user)
}
function clearFileNumber(){
    localStorage.removeItem(keys.currentFileNumber)
}
function clearBranchInfo(){
    localStorage.removeItem(keys.branchInfo)
}


function getUser(){

    return JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.user)))+"");
}
function setBranchInfo(branchInfo:any){
    localStorage.setItem(keys.branchInfo,Cryptography.encriptString(JSON.stringify(branchInfo)))
}
function getBranchInfo(){

    return JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.branchInfo)))+"");
}
function setData(data:any){
    localStorage.setItem(keys.data,Cryptography.encriptString(JSON.stringify(data)))
}
function getData(){

    return JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.data)))+"");
}
function setToken(token:any){
    localStorage.setItem(keys.token,Cryptography.encriptString(JSON.stringify(token)))
}
function getToken(){

    return JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.token)))+"");
}
function setName(argName: string) {
    localStorage.setItem(keys.name, Cryptography.encriptString(argName));
}
function getName(): string {
    return(Cryptography.decriptString(localStorage.getItem(keys.name)) || "");
}

function setDeviceId(argDeviceId: string) {
    localStorage.setItem(keys.deviceId, Cryptography.encriptString(argDeviceId));
}
function getDeviceId(): string {

    return(Cryptography.decriptString(localStorage.getItem(keys.deviceId)) || "");
}

function setPreRequestId(argRequestId: string) {
    localStorage.setItem(keys.preRequestId, Cryptography.encriptString(argRequestId));
}
function getPreRequestId(): any {
    return(Cryptography.decriptString(localStorage.getItem(keys.preRequestId)));
}
function clearPreRequestId() {
    localStorage.removeItem(keys.preRequestId);
}

function setGoToForm(argRequestId: string) {
    localStorage.setItem(keys.goToForm, Cryptography.encriptString(argRequestId));
}
function getGoToForm() {
    return(Cryptography.decriptString(localStorage.getItem(keys.goToForm)));
}
function clearGoToForm() {
    localStorage.removeItem(keys.goToForm);
}

async function  setFormData(data: any) {

    return  new Promise((resolve, reject) => {
        localStorage.setItem(keys.accountTypes,Cryptography.encriptString(JSON.stringify(data.account_types)))
        localStorage.setItem(keys.billingReviewTypes,Cryptography.encriptString(JSON.stringify(data.billing_review_types)))
        localStorage.setItem(keys.cities,Cryptography.encriptString(JSON.stringify(data.cities)))
        localStorage.setItem(keys.units,Cryptography.encriptString(JSON.stringify(data.units)))
        localStorage.setItem(keys.legalFacilitiesRequestType,Cryptography.encriptString(JSON.stringify(data.legal_facilities_request_type)))
        localStorage.setItem(keys.constructionDocumentType,Cryptography.encriptString(JSON.stringify(data.construction_document_type)))

    });

}
function getFormData(): any {
    let formData = new FormData();
    const legalFacilitiesRequestType= JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.legalFacilitiesRequestType)))+"")?JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.legalFacilitiesRequestType)))+""):[];
    const units= JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.units)))+"")?JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.units)))+""):[];
    const cities= JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.cities)))+"")?JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.cities)))+""):[];
    const constructionDocumentType= JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.constructionDocumentType)))+"")?JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.constructionDocumentType)))+""):[];
    const accountType= JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.accountTypes)))+"")?JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.accountTypes)))+""):[];
    const billing_review_types= JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.billingReviewTypes)))+"")?JSON.parse((Cryptography.decriptString(localStorage.getItem(keys.billingReviewTypes)))+""):[];
    for(const singleItem of accountType) {
        const styledItem = new ValueLabel();
        styledItem.label = singleItem["name"];
        styledItem.value = singleItem["id"];
        formData.account_types.push(styledItem);
    }

    for(const singleItem of billing_review_types) {
        const styledItem = new ValueLabel();
        styledItem.label = singleItem["name"];
        styledItem.value = singleItem["id"];
        formData.billing_review_types.push(styledItem);
    }
    for(const singleItem of cities) {
        const styledItem = new ValueLabel();
        styledItem.label = singleItem["name"];
        styledItem.value = singleItem["id"];
        formData.cities.push(styledItem);
    }

    for(const singleItem of constructionDocumentType) {
        const styledItem = new ValueLabel();
        styledItem.label = singleItem["name"];
        styledItem.value = singleItem["id"];
        formData.construction_document_type.push(styledItem);
    }
    for(const singleItem of legalFacilitiesRequestType) {
        const styledItem = new ValueLabel();
        styledItem.label = singleItem["name"];
        styledItem.value = singleItem["id"];
        formData.legal_facilities_request_type.push(styledItem);

    }

    return formData;
}
function clearFormData() {
    localStorage.removeItem(keys.formData);
}

function setIsStoredInstallerInformation() {
    localStorage.setItem(keys.storeInstallerInformation, Cryptography.encriptString("#Es?Rs&Wf2Ynb9W"));
}
function getIsStoredInstallerInformation(): any {
    return(Cryptography.decriptString(localStorage.getItem(keys.storeInstallerInformation)));
}

function clearAll() {
    localStorage.clear();
    // clearCellphone();
    // clearName();
    // for(let i = 0; i < 1000000; i++) {
    //     const thisSaved = getSavedForm(i);
    //     if(thisSaved === null) {
    //         break;
    //     }
    //     clearSavedForm(i);
    // }
}

export default {
    setBranchInfo,
    setToken,getToken,
    getBranchInfo,
    setCellphone, getCellphone,
    setData, getData,
    setDeviceId, getDeviceId,
    setUser,getUser,
    setFileNumber,getFileNumber,
    clearFileNumber,clearBranchInfo,
    setPreRequestId, getPreRequestId, clearPreRequestId,
    setIsStoredInstallerInformation, getIsStoredInstallerInformation,
    setFormData, getFormData, clearFormData,
    setGoToForm, getGoToForm, clearGoToForm,
    clearUser,
    clearAll
};
